import React from 'react';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined';
import ChangelogMedia from './ChangelogMedia';
import { areaLabel, planBadgeText, typeInfo } from './changelogConfig';
import styles from './Changelog.module.css';

/**
 * Cartão de uma novidade.
 *
 * Props:
 *   entry          - novidade publicada (useChangelog)
 *   highlight      - destaque: cartão maior, com imagem ou vídeo
 *   showPlan       - mostra o selo "Disponível a partir do plano X"
 *   onPlanClick    - opcional; com ele o selo vira atalho para o upgrade (vitrine, nunca bloqueio)
 *   onOpenScreen   - opcional; com ele aparece "Ver na tela" (só para quem está logado)
 */
const ChangelogEntryCard = ({ entry, highlight = false, showPlan = false, onPlanClick, onOpenScreen }) => {
  const type = typeInfo(entry.type);
  const area = areaLabel(entry.area);
  const planText = showPlan ? planBadgeText(entry.plan) : null;
  const canOpen = Boolean(onOpenScreen && entry.link);

  const planBadge = planText && (onPlanClick ? (
    <button type="button" className={`${styles.planBadge} ${styles.planBadgeButton}`} onClick={() => onPlanClick(entry)}>
      <WorkspacePremiumOutlinedIcon sx={{ fontSize: 14 }} />
      {planText}
    </button>
  ) : (
    <span className={styles.planBadge}>
      <WorkspacePremiumOutlinedIcon sx={{ fontSize: 14 }} />
      {planText}
    </span>
  ));

  return (
    <article className={`${styles.card} ${highlight ? styles.cardHighlight : ''}`} id={`novidade-${entry.id}`}>
      {highlight && <ChangelogMedia entry={entry} />}
      <div className={styles.cardBody}>
        <div className={styles.cardMeta}>
          <span className={styles.typeChip} style={{ color: type.color, backgroundColor: type.bg }}>
            {type.label}
          </span>
          {area && <span className={styles.area}>{area}</span>}
          {planBadge}
        </div>
        <h3 className={highlight ? styles.highlightTitle : styles.cardTitle}>{entry.title}</h3>
        {entry.summary && <p className={styles.summary}>{entry.summary}</p>}
        {canOpen && (
          <button type="button" className={styles.openButton} onClick={() => onOpenScreen(entry.link)}>
            {entry.cta || 'Ver na tela'}
            <ArrowForwardIcon sx={{ fontSize: 16 }} />
          </button>
        )}
      </div>
    </article>
  );
};

export default ChangelogEntryCard;
